import Handsontable from 'handsontable';
import AppColors from '../../../../constants/AppColors';
import '../../styles.css';

class AuditSheetEditor extends Handsontable.editors.NumericEditor {
  init() {
    super.init();
  }
}

function getScaledRowFontSize(scale) {
  return 14 * scale + 'px';
}

function customDropdownRenderer(
  instance,
  td,
  row,
  col,
  prop,
  value,
  cellProperties
) {
  td.style.textAlign = 'center';
  td.style.fontSize = getScaledRowFontSize(cellProperties?.scale);
  const placeholder = cellProperties.placeholder;
  if (!value && placeholder) {
    td.innerText = placeholder;
    td.style.color = '#ccc';     
    td.style.fontStyle = 'italic';  
  }
  Handsontable.renderers.AutocompleteRenderer(
    instance,
    td,
    row,
    col,
    prop,
    value,
    cellProperties
  );
}

function currencyRenderer(instance, td, row, col, prop, value, cellProperties) {
  if (value && !''.startsWith('$')) {
    value = `$${value}`;
  }

  td.style.textAlign = 'center';
  td.style.fontSize = getScaledRowFontSize(cellProperties?.scale);
  td.style.background = AppColors.lightPink;
  Handsontable.renderers.TextRenderer(
    instance,
    td,
    row,
    col,
    prop,
    value,
    cellProperties
  );
}

  const CustomDropdownEditor = Handsontable.editors.DropdownEditor.prototype.extend();

  CustomDropdownEditor.prototype.open = function () {
    // call original open
    Handsontable.editors.DropdownEditor.prototype.open.apply(this, arguments);

    // const highlightValue = this.cellProperties?.highlightValue;
    const highlightValue = this.cellProperties.placeholder
    const innerHOT = this.htEditor;

    
  if (!innerHOT) return;

    innerHOT.updateSettings({
      cells: (row, col) => {
        return {
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            Handsontable.renderers.TextRenderer(
              instance,
              td,
              row,
              col,
              prop,
              value,
              cellProperties
            );

            if (value === highlightValue) {
              td.style.backgroundColor = '#ffeeba';
              td.style.fontWeight = 'bold';
            }
          }
        };
      }
    });

    // Scroll dropdown viewport to the highlighted option
    const rowIndex = innerHOT
      .getSourceData()
      .findIndex(v => v === highlightValue);

    if (rowIndex >= 0) {
      innerHOT.scrollViewportTo(rowIndex, 0);
    }
     // 3. Delay deselection to ensure first row isn’t selected
  setTimeout(() => {
    innerHOT.deselectCell(true); // now happens **after internal Handsontable selection**
  }, 0);

  };

  CustomDropdownEditor.prototype.finishEditing = function (...args) {
    const newValue = this.getValue();

    if (newValue === '' || !newValue) {
      this.cancelChanges();
    }

    Handsontable.editors.DropdownEditor.prototype.finishEditing.apply(this, args);
  };

export function registerCustomCells({ scale }) {
  Handsontable.cellTypes.registerCellType('audit_sheet.currency_renderer', {
    editor: AuditSheetEditor,
    renderer: currencyRenderer,
    validator: Handsontable.validators.NumericValidator,
    // You can add additional options to the cell type
    // based on Handsontable settings
    allowInvalid: false,
    type: 'numeric',
    scale: scale,
  });

  Handsontable.cellTypes.registerCellType('audit_sheet.dropdown_renderer', {
    editor: CustomDropdownEditor,
    renderer: customDropdownRenderer,
    validator: Handsontable.validators.AutocompleteValidator,
    // You can add additional options to the cell type
    // based on Handsontable settings
    allowInvalid: false,
    // scale: scale,
  });

  Handsontable.cellTypes.registerCellType('audit_sheet.currency_renderer', {
    editor: AuditSheetEditor,
    renderer: currencyRenderer,
    validator: Handsontable.validators.NumericValidator,
    // You can add additional options to the cell type
    // based on Handsontable settings
    allowInvalid: false,
    type: 'numeric',
    scale: scale,
  });

  // custom styles for cells
  Handsontable.renderers.registerRenderer(
    'customStylesRenderer',
    (hotInstance, TD, ...rest) => {
      Handsontable.renderers.getRenderer('text')(hotInstance, TD, ...rest);
      TD.style.fontSize = getScaledRowFontSize(scale);
      TD.style.textAlign = 'center';
    }
  );

  // custom styles for notes
  Handsontable.renderers.registerRenderer(
    'audit_sheet.notes_renderer',
    (hotInstance, TD, row, column, prop, value, cellProperties) => {
      Handsontable.renderers.getRenderer('text')(
        hotInstance,
        TD,
        row,
        column,
        prop,
        value,
        cellProperties
      );
      if (value != null && (['notes', 'response', 'provider_education', 'number_complexity', 'amount_complexity', 'risk_complications'].includes(prop))){
        if(cellProperties.readOnly){
          TD.innerHTML = value
          TD.style.whiteSpace="nowrap"
          TD.style.overflow = "hidden"
          TD.style.textOverflow= "ellipsis"
          TD.classList.add('expandable-notes-cell');
          TD.addEventListener('dblclick', () => {
            TD.style.whiteSpace="normal"
          });
        }else{
          TD.innerText = value
        }
        if(prop === 'response'){
          TD.style.textAlign = 'center';
        }
      }
    }
  );

  Handsontable.renderers.registerRenderer(
    'customStylesRendererCheckbox',
    (hotInstance, TD, row, column, prop, value, cellProperties) => {
      Handsontable.renderers.getRenderer('checkbox')(hotInstance, TD, row, column, prop, value, cellProperties);
      TD.style.fontSize = getScaledRowFontSize(scale);
      TD.style.textAlign = 'center';
    }
  );

  Handsontable.renderers.registerRenderer(
    'cptIcdStylerRenders',
    (hotInstance, TD, row, column, prop, value, cellProperties) => {
      Handsontable.renderers.getRenderer('numeric')(
        hotInstance,
        TD,
        row,
        column,
        prop,
        value,
        cellProperties
      );
      TD.style.fontSize = getScaledRowFontSize(scale);
      TD.style.textAlign = 'center';
      if (value !== null && value !== false && typeof value === 'string') {
        const dotIndex = value?.indexOf('.');
        if (dotIndex !== -1) {
          TD.innerHTML = value.slice(0, dotIndex + 6);
        } else {
          TD.innerHTML = value;
        }
      }
    }
  );

  Handsontable.renderers.registerRenderer(
    'agreeRenderer',
    (hotInstance, TD, row, column, prop, value, cellProperties) => {
      Handsontable.renderers.getRenderer('text')(
        hotInstance,
        TD,
        row,
        column,
        prop,
        value,
        cellProperties
      );
      TD.style.fontSize = getScaledRowFontSize(scale);
      TD.style.textAlign = 'center';
      if (value != null) {
        TD.innerHTML = value === true || value === 'true' ? 'Yes' : '-';
      }
    }
  );
  Handsontable.renderers.registerRenderer(
    'hoverCPTRenderer',
    (hotInstance, TD, row, column, prop, value, cellProperties) => {
      // Use the default text renderer
      Handsontable.renderers.getRenderer('text')(
        hotInstance,
        TD,
        row,
        column,
        prop,
        value,
        cellProperties
      );
  
      // Add a tooltip only if `description` exists
      TD.style.textAlign = 'center';
    if (value && cellProperties.CPT) {
      try{
        const codeOnly = value.split('*')[0];
        TD.setAttribute('title', `${cellProperties.CPT[codeOnly].description.replace(/\s+/g, ' ').trim()}`);
        TD.classList.add('ht-tooltip');
      }catch{
        TD.removeAttribute('title');
        TD.classList.remove('ht-tooltipp');
      }
    } else {
      TD.removeAttribute('title');
      TD.classList.remove('ht-tooltipp');
    }
    }
  );  
  Handsontable.renderers.registerRenderer(
    'hoverICDRenderer',
    (hotInstance, TD, row, column, prop, value, cellProperties) => {
      // Use the default text renderer
      Handsontable.renderers.getRenderer('text')(
        hotInstance,
        TD,
        row,
        column,
        prop,
        value,
        cellProperties
      );
  
      // Add a tooltip only if `description` exists
      TD.style.textAlign = 'center';
      if (value && cellProperties.ICD) {
        try{
          TD.setAttribute('title', `${cellProperties.ICD[value].description.replace(/\s+/g, ' ').trim()}`);
          TD.classList.add('ht-tooltipp');
        }catch{
          TD.removeAttribute('title');
          TD.classList.remove('ht-tooltipp');
        }
      } else {
        TD.removeAttribute('title');
        TD.classList.remove('ht-tooltipp');
      }
    }
  );

  Handsontable.renderers.registerRenderer(
    'hoverModifierRenderer',
    (hotInstance, TD, row, column, prop, value, cellProperties) => {
      // Use the default text renderer
      Handsontable.renderers.getRenderer('text')(
        hotInstance,
        TD,
        row,
        column,
        prop,
        value,
        cellProperties
      );
  
      // Add a tooltip only if `description` exists
      TD.style.textAlign = 'center';
      if (value && cellProperties.Modifiers) {
        try{
          const modifiers = value.split(',').map(mod => mod.trim()); // Split and trim each value
          let descriptions = '';
          if(modifiers.length >1){
            descriptions = modifiers.map(mod => 
              `${mod}: ${cellProperties.Modifiers[mod]?.description.replace(/\s+/g, ' ').trim() || ''}`
            ).join('\n');
          }else{
            descriptions = cellProperties.Modifiers[modifiers[0]]?.description.replace(/\s+/g, ' ').trim() || ''
          }
          TD.setAttribute('title', descriptions);
          TD.classList.add('ht-tooltipp');
        }catch{
          TD.removeAttribute('title');
          TD.classList.remove('ht-tooltipp');
        }
      } else {
        TD.removeAttribute('title');
        TD.classList.remove('ht-tooltipp');
      }
    }
  );
}
